module.exports = __webpack_public_path__ + "img/playlist_logo.44562e07.png";